import React from 'react';

import LoginForm from './Form';

class LoginPage extends React.Component {
  render() {
    return (
      <div style={{maxWidth:"1356px",margin:"0 auto"}}>
        <LoginForm />
      </div>
    );
  }
}

export default LoginPage;